import {
  FormLayout,
  Panel,
  PanelSection,
  PanelHeader,
  PanelTitle,
  PanelDescription,
  FormLayoutGroup,
} from '@customerio/pluma-components/react';
import { TextField, TextArea, Select, withForm } from '@/components/form';
import { INDUSTRIES } from '@/features/ai-business-profile/helpers/industries';
import { CUSTOM_INDUSTRY_OPTION_VALUE, formOpts } from '@/features/ai-business-profile/helpers/form';
import { useStore } from '@tanstack/react-form';

const industryOptions = [
  ...INDUSTRIES.map((industry) => ({
    value: industry,
    label: industry,
  })),
  { value: CUSTOM_INDUSTRY_OPTION_VALUE, label: 'Other' },
];

export const BasicInfo = withForm({
  ...formOpts,
  props: {
    canEdit: true,
  },
  render: function BasicInfo({ form, canEdit }) {
    const industry = useStore(form.store, (state) => state.values.industry);

    return (
      <Panel>
        <PanelHeader>
          <PanelTitle>Basic info</PanelTitle>
          <PanelDescription>Tell us about your company, what you do, and who you serve.</PanelDescription>
        </PanelHeader>
        <PanelSection>
          <FormLayout>
            {/* Default form layout group doesn't stay fixed to its width in error state */}
            <FormLayoutGroup display="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <TextField
                name="name"
                api={form}
                label="Business name"
                placeholder="Enter your business name"
                isDisabled={canEdit === false}
              />
              <TextField
                name="websiteUrl"
                api={form}
                label="Website"
                placeholder="https://example.com"
                isDisabled={canEdit === false}
              />
            </FormLayoutGroup>
            <FormLayoutGroup display="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <Select
                label="Industry"
                name="industry"
                api={form}
                isSearchable={true}
                options={industryOptions}
                placeholder="Select your industry"
                description="If your industry isn't listed, please select Other"
                isDisabled={canEdit === false}
              />
              {industry === CUSTOM_INDUSTRY_OPTION_VALUE ? (
                <TextField
                  name="customIndustry"
                  api={form}
                  label="Other industry"
                  placeholder="Enter your industry"
                  isDisabled={canEdit === false}
                />
              ) : null}
            </FormLayoutGroup>
            <TextArea
              name="longDescription"
              api={form}
              label="Business description"
              placeholder="Briefly describe what your business does and the value you provide"
              minRows={4}
              description="Explain what your business does, the products or services you offer, and the value you provide to customers"
              isDisabled={canEdit === false}
            />
            <TextArea
              name="audience"
              api={form}
              label="Audience"
              placeholder="Who are your primary customers or users?"
              minRows={4}
              description='Describe your target audience, customer segments, or user personas (e.g. "Small business owners, marketing managers at mid-size companies, developers")'
              isDisabled={canEdit === false}
            />
          </FormLayout>
        </PanelSection>
      </Panel>
    );
  },
});
